/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";
import { liteClient as algoliasearch } from "algoliasearch/lite";
// import { SearchClient } from "instantsearch.js";
import { SearchClient } from "instantsearch.js";
import { createInsightsMiddleware } from "instantsearch.js/es/middlewares/createInsightsMiddleware";
import { Suspense, useLayoutEffect } from "react";
import { InstantSearch, useInstantSearch } from "react-instantsearch";
import aa from "search-insights";

import { css } from "@/../styled-system/css";

import CustomHits from "./CustomHits";
import CustomSearchBoxShade from "./CustomSearchBoxShade";
import NewSearchBar from "./NewSearchBar";
import SearchbarSkeleton from "../Skeleton/SearchbarSkeleton";

const algoliaClient = algoliasearch(
  process.env.NEXT_PUBLIC_ALGOLIA_APP_ID!,
  process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_ONLY_API_KEY!,
);

const searchClient: SearchClient = {
  ...algoliaClient,
  search(requests: any) {
    if (requests.every(({ params }: { params: any }) => !params.query)) {
      return Promise.resolve({
        results: requests.map(() => ({
          hits: [],
          nbHits: 0,
          nbPages: 0,
          page: 0,
          processingTimeMS: 0,
          hitsPerPage: 0,
          exhaustiveNbHits: false,
          query: "",
          params: "",
        })),
      });
    }

    return algoliaClient.search(requests);
  },
};

const searchBoxContainerClass = css({
  width: "100%",
  gridColumn: "span 2",
  order: "3",
  sm: {
    ml: "auto",
    maxWidth: "360px",
  },
  md: {
    ml: "0",
    display: "block",
    gridColumn: "1",
  },
});

function InsightsMiddleware({ userToken }: { userToken: string | null }) {
  const { addMiddlewares } = useInstantSearch();
  // TODO:based on cookies
  useLayoutEffect(() => {
    const fetchUserToken = async () => {
      const authenticatedUserToken = userToken;

      if (!authenticatedUserToken) {
        return;
      }
      // TODO:debug events

      // Ensure only allowed chars and max length of 64
      const sanitizedToken = authenticatedUserToken.replace(
        /[^a-zA-Z0-9_-]/g,
        "",
      );
      const validToken = sanitizedToken.substring(0, 64);

      aa("init", {
        appId: process.env.NEXT_PUBLIC_ALGOLIA_APP_ID!,
        apiKey: process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_ONLY_API_KEY!,
        userToken: validToken,
        useCookie: true,
        authenticatedUserToken: validToken,
      });

      const middleware = createInsightsMiddleware({
        insightsClient: aa,
      });

      addMiddlewares(middleware);
    };

    fetchUserToken();
  }, [addMiddlewares, userToken]);

  return null;
}

interface SearchProps {
  token: string | null;
}

export default function Search({ token }: SearchProps) {
  const ALGOLIA_SEARCH_INDEX = process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_INDEX!;

  return (
    <InstantSearch searchClient={searchClient} indexName={ALGOLIA_SEARCH_INDEX}>
      <InsightsMiddleware userToken={token} />
      <Suspense fallback={<SearchbarSkeleton />}>
        <div className={searchBoxContainerClass}>
          <NewSearchBar />
        </div>
      </Suspense>
      <CustomHits />
    </InstantSearch>
  );
}
